import styles from './styles.module.css'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box } from '@chakra-ui/core'
import { CategorySelector } from '../../Steps/SubtaskCreationStep/Widgets/CategorySelector'

export function BuilderSubtaskSettings({
  subtaskPath,
  defaultCategory,
}: {
  subtaskPath: string
  defaultCategory?: string
}) {
  const { control } = useFormContext()

  return (
    <section className={styles.section}>
      {/* Keep this leaf mounted when its header control is hidden or switches to another card. */}
      <Controller
        name={`${subtaskPath}.is_required`}
        control={control}
        defaultValue={true}
        as={<Box display="none" />}
      />
      <CategorySelector subtaskPath={subtaskPath} defaultCategory={defaultCategory} />
    </section>
  )
}
